/**
 * 个人中心左侧菜单枚举
 * 新增菜单：在此追加 MY_MENU 与 MY_MENU_ITEMS 一项即可，无需调整数字下标
 */
export const MY_MENU = {
  PROFILE: "profile",
  COMPANY: "company",
  PERFORMANCE: "performance",
  CONTRACT: "contract",
  ALLIES: "allies",
  LICENSE_APPLY: "licenseApply",
  CERTIFICATE: "certificate",
  LICENSE: "license",
  STAFF: "staff",
  NOTIFICATIONS: "notifications",
};

/** 菜单配置：factoryOnly=true 表示仅盘厂用户可见 */
export const MY_MENU_ITEMS = [
  { key: MY_MENU.PROFILE, label: "个人资料", factoryOnly: false },
  { key: MY_MENU.COMPANY, label: "企业信息", factoryOnly: false },
  { key: MY_MENU.PERFORMANCE, label: "业绩信息", factoryOnly: false },
  { key: MY_MENU.CONTRACT, label: "合同管理", factoryOnly: false },
  { key: MY_MENU.ALLIES, label: "我的盟友", factoryOnly: false },
  { key: MY_MENU.LICENSE_APPLY, label: "License账号申请", factoryOnly: false },
  { key: MY_MENU.CERTIFICATE, label: "授权证书", factoryOnly: false },
  { key: MY_MENU.LICENSE, label: "授权软件激活码", factoryOnly: false },
  { key: MY_MENU.STAFF, label: "员工管理", factoryOnly: false },
  { key: MY_MENU.NOTIFICATIONS, label: "消息通知", factoryOnly: false },
];

/** 兼容旧版数字路由参数 ?act=0|1|2... */
const LEGACY_ACT_MAP = {
  0: MY_MENU.PROFILE,
  1: MY_MENU.COMPANY,
  2: MY_MENU.PERFORMANCE,
  3: MY_MENU.CERTIFICATE,
  4: MY_MENU.LICENSE,
  5: MY_MENU.STAFF,
  6: MY_MENU.CONTRACT,
  7: MY_MENU.ALLIES,
  8: MY_MENU.LICENSE_APPLY,
  9: MY_MENU.NOTIFICATIONS,
};

/**
 * 将路由参数或任意入参解析为合法菜单 key
 * @param {string|number} val - 如 'company'、'performance' 或旧版数字 1
 * @returns {string}
 */
export function resolveMenuKey(val) {
  if (val === undefined || val === null || val === "") {
    return MY_MENU.PROFILE;
  }
  const str = String(val);
  if (Object.values(MY_MENU).includes(str)) {
    return str;
  }
  const legacyKey = LEGACY_ACT_MAP[Number(str)];
  return legacyKey || MY_MENU.PROFILE;
}

/**
 * 根据用户类型过滤可见菜单
 * @param {number} userType - 1 盘厂，其它为业务员等
 * @returns {Array}
 */
export function getVisibleMenuItems(userType) {
  return MY_MENU_ITEMS.filter(
    (item) => !item.factoryOnly || userType == 1
  );
}
